import { useServicesContext } from "@/modules/core/services/services.context"
import { financeKeys } from "@/modules/finances/gateway/financeKeys"
import { PaymentsToValidateEnumApi } from "@/modules/finances/paymentsToValidate/gateway/paymentsToValidateApi"
import { paymentsToValidateKeys } from "@/modules/finances/paymentsToValidate/gateway/paymentsToValidateKeys"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export const usePaymentsToValidateActions = () => {
  const { paymentsToValidateApi } = useServicesContext()
  const queryClient = useQueryClient()

  const abandonPaymentMutation = useMutation({
    mutationFn: async ({ api, transactionId }: { api: PaymentsToValidateEnumApi; transactionId: string }) => {
      return await paymentsToValidateApi.abandonPayment(api, transactionId)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: paymentsToValidateKeys.all })
      queryClient.invalidateQueries({ queryKey: financeKeys.all })
    },
  })

  return {
    abandonPaymentMutation,
  }
}
